export const landingHeroSrc = `${process.env.PUBLIC_URL}/images/landing/new/hero2x.webp`;
export const landingIntroOne = `${process.env.PUBLIC_URL}/images/landing/new/save.webp`;
export const landingIntroTwo = `${process.env.PUBLIC_URL}/images/landing/new/organize.webp`;
export const landingIntroThree = `${process.env.PUBLIC_URL}/images/landing/new/collaborate.webp`;
export const arrowImage = <img style={{ height: "20px", marginLeft: "3px", marginBottom: "3px"}} src={`${process.env.PUBLIC_URL}/images/landing/arrow-right.svg`} alt='learn-more' />
